"use client";

import { useI18n } from "@wojo/localization";
import { Button, Card, Markdown, Text } from "@wojo/ui";
import styles from "./GlobalRewardsBenefitsCard.module.scss";
import { useSuspenseQuery } from "@apollo/client";
import {
    MyGlobalRewardsSummaryDocument,
    MyGlobalRewardsSummaryQuery,
} from "generated/graphql";
import { FiExternalLink } from "react-icons/fi";

export const GlobalRewardsBenefitsCard: React.FC = () => {
    const { data } = useSuspenseQuery<MyGlobalRewardsSummaryQuery>(
        MyGlobalRewardsSummaryDocument,
    );
    const benefitsI18n =
        useI18n("account").account.loyalty.globalRewardsBenefitsCard;
    const summary = data.myGlobalRewardsSummary;

    const pendingPointsEnabled =
        process.env.NEXT_PUBLIC_GLOBAL_REWARDS_PENDING_POINTS_ENABLED ===
        "true";

    if (!summary || !benefitsI18n) {
        return null;
    }

    return (
        <Card className={styles.card}>
            <div>
                <Text.Body emphasis="1" variant="2">
                    {benefitsI18n.pointsAvailableTitle.l()}
                </Text.Body>
                <Text.Heading
                    tag="p"
                    order="4"
                    style={
                        pendingPointsEnabled
                            ? {
                                  marginBottom: "var(--g-spacing-md)",
                              }
                            : undefined
                    }
                >
                    {summary.pointsActive}
                </Text.Heading>
            </div>
            {pendingPointsEnabled && (
                <div>
                    <Text.Body emphasis="1" variant="2">
                        {benefitsI18n.pointsPendingTitle.l()}
                    </Text.Body>
                    <Text.Heading tag="p" order="4">
                        {summary.pointsPending}
                    </Text.Heading>
                </div>
            )}
            <div className={styles.separator} />
            <Markdown
                markdown={benefitsI18n.description.l()}
                linksAreExternal
            />
            <Button
                variant="quiet"
                tag="a"
                href={benefitsI18n.viewUrl.l()}
                className={styles["view-link"]}
                target="_blank"
            >
                <span aria-hidden>{benefitsI18n.view.l()}</span>
                <span className="visually-hidden">
                    {benefitsI18n.viewAccessibleText.l()}
                </span>
                <FiExternalLink aria-label={benefitsI18n.externalLinkAlt.l()} />
            </Button>
        </Card>
    );
};
